import React, { useRef } from "react";

import styled from "styled-components";

import useToast from "components/atoms/toast/useToast";

import ReferenceBibInfoForm from "components/organisms/reference/ReferenceBibInfoForm";
import AbstractModal from "components/page/modal/AbstractModal";

import { getDefaultBibtex } from "utils/bibtex";

const Container = styled.div`
    width: 100%;
`;

function ReferenceAddFormModal(props) {
    const { setToast } = useToast();

    const formRef = useRef();
    const handleAddButton = () => {
        const bibJson = formRef.current.getCurrentBibJson();
        props.mutation.mutate(
            {
                body: {
                    bib_json: bibJson,
                    display_name: bibJson.title || "제목없는 참고문헌",
                },
            },
            {
                onSuccess: () => {
                    setToast("저장되었습니다.", "info");
                },
            },
        );
    };

    return (
        <AbstractModal
            modalTitle="참고문헌 추가"
            width={560}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "추가",
                leftOnClick: props.exitModal,
                rightOnClick: handleAddButton,
            }}
        >
            <Container>
                <ReferenceBibInfoForm
                    ref={formRef}
                    bibliography={{
                        id: undefined,
                        bib_json: getDefaultBibtex().bib_json,
                    }}
                />
            </Container>
        </AbstractModal>
    );
}

export default ReferenceAddFormModal;
